const comments = [
  {
    name: '追剧小达人',
    time: '2小时前',
    text: '天天影院更新速度真的快！庆余年3刚播完没几分钟就能看了，画质也清晰，再也不用到处找资源了。',
    avatar: 'https://readdy.ai/api/search-image?query=Closeup%20portrait%20of%20a%20young%20Asian%20woman%20with%20warm%20smile%2C%20soft%20natural%20lighting%2C%20clean%20cream%20background%2C%20casual%20style%2C%20friendly%20expression&width=80&height=80&seq=avatar-user-01&orientation=squarish',
  },
  {
    name: '韩剧迷妹',
    time: '5小时前',
    text: '背着善宰跑太好看了，感谢天天影院整理了全集韩剧资源，还有中文字幕，观看起来特别方便。',
    avatar: 'https://readdy.ai/api/search-image?query=Closeup%20portrait%20of%20a%20young%20Asian%20woman%20with%20glasses%2C%20warm%20indoor%20lighting%2C%20cream%20background%2C%20gentle%20smile%2C%20casual%20outfit&width=80&height=80&seq=avatar-user-02&orientation=squarish',
  },
  {
    name: '美剧老司机',
    time: '8小时前',
    text: '一直在找能稳定看美剧的地方，天天影院的美剧全集播放很流畅，不卡顿不缓冲，画质也够清晰。',
    avatar: 'https://readdy.ai/api/search-image?query=Closeup%20portrait%20of%20a%20young%20Asian%20man%20with%20casual%20style%2C%20warm%20indoor%20lighting%2C%20cream%20background%2C%20relaxed%20expression&width=80&height=80&seq=avatar-user-03&orientation=squarish',
  },
  {
    name: '日剧爱好者',
    time: '12小时前',
    text: '日剧全集资源很全，很多冷门日剧这里都能找到，而且更新很及时，每天都有新内容上线。',
    avatar: 'https://readdy.ai/api/search-image?query=Closeup%20portrait%20of%20a%20young%20Asian%20woman%20with%20long%20hair%2C%20warm%20lighting%2C%20cream%20background%2C%20happy%20expression%2C%20natural%20look&width=80&height=80&seq=avatar-user-04&orientation=squarish',
  },
  {
    name: '国产剧铁粉',
    time: '1天前',
    text: '繁花和与凤行都追完了，现在在看玫瑰的故事，天天影院真是国产剧全集在线的宝藏平台。',
    avatar: 'https://readdy.ai/api/search-image?query=Closeup%20portrait%20of%20a%20young%20Asian%20man%20with%20short%20hair%2C%20warm%20lighting%2C%20cream%20background%2C%20friendly%20smile%2C%20casual%20look&width=80&height=80&seq=avatar-user-05&orientation=squarish',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto">
          <div className="text-center mb-10">
            <span className="inline-block text-xs font-medium text-accent-600 bg-accent-100 px-3 py-1 rounded-full mb-3">
              真实反馈
            </span>
            <h2 className="text-xl md:text-3xl font-bold font-heading text-foreground-950">
              观众热评
            </h2>
            <p className="text-sm text-foreground-500 mt-2">听听追剧伙伴们怎么说</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {comments.map((comment, i) => (
              <div
                key={i}
                className="bg-background-50 rounded-xl p-5 border border-background-200/70"
              >
                <div className="flex items-start gap-3 mb-3">
                  <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                    <img
                      src={comment.avatar}
                      alt={comment.name}
                      className="w-full h-full object-cover"
                      loading="lazy"
                    />
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-semibold text-foreground-900">{comment.name}</p>
                    <p className="text-xs text-foreground-400">{comment.time}</p>
                  </div>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed">{comment.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}